import { z } from 'zod'

// manual pin of the effective drop% / shift% for one instrument. each field is
// independent: a number pins that value, null clears it back to the computed
// (disproportion-interpolated) value. omitting a field leaves it unchanged.
export const setBotInstrumentPinSchema = z.object({
  dropPercent: z.number().min(0).max(100).nullable().optional(),
  shiftPercent: z.number().min(0).max(100).nullable().optional(),
})

export type SetBotInstrumentPinDto = z.infer<typeof setBotInstrumentPinSchema>
